import React from 'react';
import HeroSection from './components/HeroSection';
import WhatWeOffer from './components/whatWeOffer';
import TherapiesServices from './components/TherapiesServices';
import OurTeam from './components/OurTeam';
import ExpectFromAppointment from './components/ExpectFromAppointment';
import EducationServices from './components/EducationServices';
import Telehealth from './components/Telehealth';
import Resources from './components/Resources';
import Spotlight from '../../components/organisms/Spotlight';
import LinksSlider from './components/LinksSlider';
import { Helmet } from 'react-helmet';
import InsuranceSection from './components/InsuranceSection';

const HomePage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Children's Physical, Occupational & Speech Therapy in Alaska |
          Guidepost Pediatrics
        </title>
        <meta
          name="description"
          content="Guidepost Pediatric Therapies offers physical, occupational, and speech therapy services in Wasilla, Alaska. Helping every child reach their full potential with state-of-the-art pediatric therapy."
        />
        <meta
          name="keywords"
          content="pediatric therapy Wasilla Alaska, speech therapy, occupational therapy, physical therapy, pediatric PT, pediatric OT, pediatric SLP, therapy services Alaska"
        />
      </Helmet>
      <HeroSection />
      <LinksSlider />
      <WhatWeOffer />
      <TherapiesServices />
      <OurTeam />
      <ExpectFromAppointment />
      <EducationServices />
      <Resources />
      <Telehealth />
      <InsuranceSection />
      <Spotlight />
    </div>
  );
};

export default HomePage;
